<template>
    <div>
        <el-card shadow='never'>
            <div slot='header' class='clearfix'>
                <span>商品支付成功后数据映射配置</span>
            </div>
            <el-form label-position='top'>
                <el-form-item label='选择'>
                    <el-select clearable @change='handleSaveTypeChange' size='mini' v-model='productSaveType'
                               placeholder='请选择'>
                        <el-option
                            v-for='item in saveOptions'
                            :key='item.value'
                            :label='item.label'
                            :value='item.value'>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if='productSaveType === "CLOUD_STORAGE"' label='选择存储映射目标'>
                    <el-cascader size='mini' v-model='cascadeValue' :options='appOptions'
                                 @change='handleChange'></el-cascader>
                </el-form-item>
                <el-form-item v-if='productSaveType === "CLOUD_STORAGE"' label='添加字段映射'>
                    <el-alert
                        style='margin-bottom: 1rem'
                        title="在用户支付成功后, 系统会自动将配置的映射字段值作为修改数据, 对配置的Class执行修改操作, 修改条件为'objectId=下单用户的userId'。客户端可以将userId作为objectId, 去对应的Class查询支付成功后的最终结果"
                        type='success'>
                    </el-alert>
                    <el-table :data='tableList' border>
                        <el-table-column prop='date' label='商品或支付订单字段'>
                            <template slot-scope='scope'>
                                <el-select @change='submitConfig' size='mini' v-model='scope.row.orderField'
                                           placeholder='请选择'>
                                    <el-option
                                        v-for='item in orderInfoOptions'
                                        :key='item.value'
                                        :label='item.label'
                                        :value='item.value'>
                                    </el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column prop='name' label='云存储字段'>
                            <template slot-scope='scope'>
                                <el-select @change='submitConfig' size='mini' v-model='scope.row.storageField'
                                           placeholder='请选择'>
                                    <el-option
                                        v-for='item in currentFieldOptions'
                                        :key='item.value'
                                        :label='item.value'
                                        :value='item.value'>
                                    </el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column prop='address' label='操作'>
                            <template slot-scope='scope'>
                                <el-button
                                    size='mini'
                                    type='text'
                                    icon='el-icon-plus'
                                    @click='handleAddMapping(scope.row)'
                                >新增映射
                                </el-button>
                                <el-button
                                    icon='el-icon-delete'
                                    size='mini'
                                    type='text'
                                    @click='removeMapping(scope.row)'
                                >删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>

<script>
import { applicationCredentialApi } from '@api/Storage/applicaitonCredentialConfig';
import { message } from '@/utils/message';
import { storageSchemaApi } from '@api/Storage/storageSchema';

export default {
    name: 'PayCloudStorageMapping',
    props: {
        projectInfoList: {
            type: Array
        },
        projectName: {
            type: String
        },
        additionalConfig: {
            type: String
        }
    },
    emits: ['submitConfig'],
    data() {
        return {
            projectInfoMap: new Map,
            projectAppId: undefined,
            appOptions: [],
            cascadeValue: [],
            currentFieldOptions: [],
            orderInfoOptions: [
                { 'label': '支付平台买家Id', 'value': 'order_buyerId' },
                { 'label': '支付平台订单号', 'value': 'order_outTradeNo' },
                { 'label': '支付平台实收金额', 'value': 'order_receiptAmount' },
                { 'label': '支付平台订单退款金额', 'value': 'order_refundAmount' },
                { 'label': '支付平台', 'value': 'order_provider' },
                
                { 'label': '公司内部订单号', 'value': 'order_id' },
                { 'label': '交易创建时间', 'value': 'order_createTime' },
                { 'label': '订单支付时间', 'value': 'order_paidTime' },
                { 'label': '订单退款时间', 'value': 'order_refundTime' },
                { 'label': '胖布丁UserId', 'value': 'order_userId' },
                { 'label': '订单状态', 'value': 'order_status' },
                { 'label': '订阅状态', 'value': 'order_subscriptionStatus' },
                
                // 商品
                { 'label': '商品Id', 'value': 'product_productId' },
                { 'label': '商品价格', 'value': 'product_price' },
                { 'label': '商品名', 'value': 'product_name' },
                { 'label': '商品数量', 'value': 'product_produceCount' }
            ],
            tableList: [{
                storageField: undefined,
                orderField: undefined
            }],
            saveOptions: [
                {
                    label: '云存储',
                    value: 'CLOUD_STORAGE'
                }
            ],
            productSaveType: undefined
            
        };
    },
    created() {
        if (this.projectName) {
            this.init();
        }
        if (this.additionalConfig) {
            this.parseConfig();
        }
    },
    watch: {
        projectInfoList() {
            this.init();
        },
        projectName() {
            this.init();
        },
        additionalConfig() {
            this.parseConfig();
        }
    },
    methods: {
        init() {
            this.productSaveType = [];
            this.appOptions = [];
            this.projectInfoMap = new Map;
            this.projectInfoList.forEach((t, index) => {
                this.projectInfoMap.set(t.name, t.appId);
                if (t.name === this.projectName) {
                    this.projectAppId = t.appId;
                }
            });
        },
        parseConfig() {
            let additionalConfig = JSON.parse(this.additionalConfig);
            let config = additionalConfig.config;
            let productSaveType = additionalConfig.productSaveType;
            this.productSaveType = productSaveType;
            if (productSaveType === 'CLOUD_STORAGE') {
                this.loadCloudApplication();
                let appId = config.appId;
                let className = config.className;
                let fieldMapping = config.fieldMapping;
                
                this.tableList = [];
                this.cascadeValue = [appId, className];
                if (this.appOptions) {
                    this.loadCloudField(this.cascadeValue);
                }
                if (fieldMapping) {
                    Object.keys(fieldMapping).forEach(orderField => {
                        let storageField = fieldMapping[orderField];
                        this.tableList.push({
                            storageField: storageField,
                            orderField: orderField
                        });
                    });
                } else {
                    this.initTable();
                }
            }
        },
        loadCloudApplication() {
            this.appOptions = [];
            applicationCredentialApi.queryList().then(result => {
                if (result.code === 200) {
                    let appList = result.data;
                    if (!appList) {
                        message.error('未找到有效的云存储应用!');
                        return;
                    }
                    let filteredAppList = appList.filter(t => t.projectAppId === this.projectAppId);
                    appList.filter(t => t.projectAppId === this.projectAppId).forEach((t, index) => {
                        let option = {
                            label: t.chineseName,
                            value: t.appId,
                            children: []
                        };
                        storageSchemaApi.queryAllSchema(t.appId).then(result => {
                            if (result.code === 200) {
                                let schemaList = result.data.results;
                                schemaList.forEach((f, fIndex) => {
                                    option.children.push({
                                        label: f.objectId,
                                        value: f.objectId,
                                        fieldOption: f.fieldOption
                                    });
                                    
                                    if (fIndex === schemaList.length - 1) {
                                        this.appOptions.push(option);
                                    }
                                    
                                    if (index === filteredAppList.length - 1 && fIndex === schemaList.length - 1) {
                                        if (this.cascadeValue.length !== 0) {
                                            this.loadCloudField(this.cascadeValue);
                                        }
                                    }
                                });
                            }
                        });
                    })
                    setTimeout(() => {
                        if (filteredAppList.length === 0) {
                            message.error('该项目未绑定云存储应用, 请先创建云存储应用!');
                        }
                    }, 2000);
                }
            });
        },
        handleChange(value) {
            this.initTable();
            this.currentFieldOptions = [];
            this.loadCloudField(value);
            this.submitConfig();
        },
        loadCloudField(value) {
            this.currentFieldOptions = [];
            this.submitConfig();
            let appId = value[0];
            let className = value[1];
            console.log(this.appOptions.length);
            this.appOptions.forEach(t => {
                if (t.value === appId) {
                    t.children.forEach(f => {
                        if (f.value === className) {
                            Object.keys(f.fieldOption).forEach(k => {
                                this.currentFieldOptions.push({
                                    label: k,
                                    value: k
                                });
                            });
                        }
                    });
                }
            });
        },
        handleAddMapping() {
            this.tableList.push({
                storageField: undefined,
                orderField: undefined
            });
            this.submitConfig();
        },
        initTable() {
            this.tableList = [{
                storageField: undefined,
                orderField: undefined
            }];
        },
        removeMapping(row) {
            this.tableList.splice(this.tableList.indexOf(row), 1);
            if (this.tableList.length === 0) {
                this.handleAddMapping();
            }
            this.submitConfig();
        },
        submitConfig() {
            let config = {
                productSaveType: this.productSaveType,
                config: {}
            };
            
            if (this.productSaveType === 'CLOUD_STORAGE') {
                config.config = {
                    appId: this.cascadeValue[0],
                    className: this.cascadeValue[1],
                    fieldMapping: {}
                };
                
                this.tableList.forEach((t, index) => {
                    if (t.orderField && t.storageField) {
                        config.config.fieldMapping[t.orderField] = t.storageField;
                    }
                    if (index === this.tableList.length - 1) {
                        this.$emit('submitConfig', config);
                    }
                });
            } else {
                this.$emit('submitConfig', null);
            }
        },
        handleSaveTypeChange() {
            if (this.productSaveType === 'CLOUD_STORAGE') {
                this.initTable();
                this.cascadeValue = [];
                this.loadCloudApplication();
            }
            this.submitConfig();
        }
    }
};
</script>

<style scoped lang='scss'>

</style>
